module.exports = __webpack_public_path__ + "static/dojazd-photo05-5bd17bf6c2f61f68ab308abdf056527e.jpg";